// extracted by mini-css-extract-plugin
export default {"shippingStatusContainer":"wE-z","shipmentMessage":"xE-z","shipmentNumber":"yE-z","trackingProgressContainer":"zE-z"};